import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

type SignUpPayload = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
};

const signUp = async (data: SignUpPayload) => {
  const response = await axios.post('/api/auth/signup', data);
  return response.data;
};

export const useSignUp = (
  onSuccess?: () => void,
  onError?: (error: any) => void,
) => {
  return useMutation({
    mutationFn: (data: SignUpPayload) => signUp(data),
    onSuccess,
    onError,
  });
};
